import { RouteComponentProps } from '@reach/router';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useEffects } from '../../state';
import css from './DocumentationPagePro.module.scss';
import { Manual } from '../../../interfaces/customer-api';
import { Spinner } from '../Spinner/Spinner';
import { Manuals } from '../Manuals/Manuals';
import { Input } from '../Input/Input';
import Search from '../../assets/search.svg';
import { Button } from '../Button/Button';
import { WidgetBreadcrumb } from '../../../interfaces/internal';
import { WidgetProps } from '../Widget/Widget';
import { SubPage } from '../SubPage/SubPage';

interface DocumentationPageOwnProps extends RouteComponentProps {
    widget: WidgetProps;
}

type Props = DocumentationPageOwnProps;

export const DocumentationPagePro: React.FunctionComponent<Props> = (props: Props) => {

    const widget = props.widget;
    
    const { t } = useTranslation(['Common', 'DocumentationTab']);
    const { api } = useEffects();
    
    const [equipmentSerialNumber, setEquipmentSerialNumber] = useState('');
    const [manuals, setManuals] = useState<Manual[]>([]);
    const [isManualsLoading, setIsManualsLoading] = useState(false);

    const fetchManuals = async () => {
        try {
            if (equipmentSerialNumber) {
                setIsManualsLoading(true);
                const data = await api.getManualsBySerialNumber(equipmentSerialNumber);
                setManuals(data);
            }
        } catch (error) {
            setManuals([]);
        } finally {
            setIsManualsLoading(false);
        }
    };

    const breadcrumb: WidgetBreadcrumb = {
        id: widget.id,
        title: widget.title,
        subPage: undefined,
    };

    return (
        <SubPage
            breadcrumb={breadcrumb}
            idSlug={widget.id}
        >
            <div id='documentation-page-pro' className={css.documentationPagePro}>
                <div className={css.columns}>
                    <Input
                        containerProps={{
                            className: css.searchField,
                        }}
                        icon= {isManualsLoading ? <Spinner size={3} /> : <Search />}
                        id='equipment-document-search'
                        inputProps={{
                            onChange: ({ target }) => setEquipmentSerialNumber(target.value),
                            placeholder: `${t('Search manuals with serial number')}...`,
                            type: 'text',
                            value: equipmentSerialNumber,
                            className: css.searchFieldInput,
                            onKeyDown: (e) => {
                                if (e.key === 'Enter') {
                                    fetchManuals();
                                }
                            },
                            disabled: isManualsLoading,
                        }}
                        
                    />  
                    <Button
                        variant='primary'
                        id='equipment-document-search-button'
                        onClick={() => fetchManuals()}
                        className={css.searchButton}
                        >
                            {t('Search')}
                    </Button>

                </div>
                
                {!isManualsLoading && manuals.length > 0 && (
                    <div className={css.columns}>
                        <div className={css.column}>    
                            <Manuals manuals={manuals} />
                        </div>
                    </div>
                )}
                {!isManualsLoading && manuals.length === 0 && (
                    <div className={css.centered}>
                        {t('No data')}
                    </div>
                )}
            </div>
        </SubPage>
    );
};
